import React from 'react'

export default function PaddingBottom({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'
    return (
        <svg
            className={className}
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path
                d='M3 7V10C3 11.1046 3.89543 12 5 12H15C16.1046 12 17 11.1046 17 10V7'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
            />
            <path d='M7 9H13' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
